<template>
  <div class="search-condition">
    <div class="filter" v-for="(f,index) in filters" :key="index">
      <span class="label">{{ f.name }}</span>
      <span class="value ft-theme">{{ f.value }}</span>
      <i class="gjw-iconfont gjw-icon-close icon-close" @click="onClose([f])" />
    </div>
    <div class="clear-filter ft-theme" v-if="filters.length" @click="onClose(filters)">
      {{ $t('component.searchClearCondition') }}
    </div>
    <div class="result">{{ $t('component.searchRelatedComponents') }} <span class="ft-theme">{{totalCount}}</span> {{ $t('component.searchCount') }}</div>
    <i class="icon-refresh gjw-iconfont gjw-icon-gongneng_shuaxin" @click="onRefresh"></i>
  </div>
</template>
<script>
export default {
  name: 'FilterCondition',
  props: {
    // 每个元素表现为：{name:'分类',value:'门',key:'keyword'}
    filters: {
      type: Array,
      default() {
        return []
      }
    },
    totalCount: {
      type: Number,
      default: null
    }
  },
  methods: {
    onClose(filters) {
      this.$emit('close', filters)
    },
    onRefresh() {
      this.$emit('refresh')
    }
  }
}
</script>
<style lang='less' scoped>
*{
  font-size: 1rem;
}
.search-condition{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  //margin-bottom: 6px;
}
.filter,.clear-filter{
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 2px;
}
.filter{
  margin: 0 8px 0 0;
  padding: 2px 6px 2px 10px;
  border: 1px solid @theme-border-color;
  .value{
    padding: 0 12px 0 6px;
  }
}
.icon-close{
  font-size: 12px;
  cursor: pointer;
}
.clear-filter{
  margin: 0 12px 0 0;
  border: 1px solid @theme-color;
  padding: 0 6px;
  cursor: pointer;
  position: relative;
}
.result{
  color: @theme-grey-2;
}
.icon-refresh{
  padding: 0 0 0 8px;
  cursor: pointer;
  color: @theme-grey-2;
}
</style>
